<template>
    <div class="center-page">
        <el-form :model="addForm" :rules="rules" label-position="right" label-width="150px" ref="forms">
            <el-form-item label="反馈的问题：" prop="title">
                <el-input style="width: 50%;" v-model="addForm.title" placeholder="反馈的问题"></el-input>
            </el-form-item>
            <el-form-item label="具体信息：" prop="content">
                <el-input type="textarea"
                          v-model="addForm.content"
                          placeholder="请输入具体信息"
                          :autosize="{ minRows: 8, maxRows: 16}"
                          maxlength="2500" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="添加照片：">
                <transition-group tag="div" name="drag" class="img-content">
                    <img @dragstart="handlerStart(item,index)"
                         @dragend="handlerEnd(item,index)"
                         @dragenter="handlerEnter(item,index)"
                         v-for="(item,index) in addForm.image"
                         @click="delImg(index)"
                         :key="item"
                         class="img-content-item" :src="`/api/v1/file/${item}`" alt="">
                    <el-upload
                            action=""
                            key="upload"
                            :http-request="uploadImage"
                            class="avatar-uploader"
                            :show-file-list="false">
                        <i slot="trigger" class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="color-red">文件大小1MB以内，支持JPG、GIF、PNG格式。</div>
                    </el-upload>
                </transition-group>
            </el-form-item>
            <el-form-item>
                <el-button v-loading="loading" type="primary" @click="adviceAdd">提交反馈</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {formVerify, delToast} from '@/utlis/decorators'

    export default {
        name: "feedback",
        data() {
            return {
                loading: false,
                addForm: {
                    title: '',
                    content: '',
                    image: []
                },
                rules: {
                    title: [{required: true, message: '请输入反馈的问题', trigger: ['blur', 'change']}],
                    content: [{required: true, message: '请输入具体信息', trigger: ['blur', 'change']}]
                }
            }
        },
        created() {
        },
        methods: {
            @delToast('是否删除该图片？')
            async delImg(index){
                this.addForm.image.splice(index, 1)
            },
            async uploadImage(e) {
                if (e.file.size / 1024 > 1024) {
                    return this.$message.warning('文件大小不能超过1M')
                }
                let form = new FormData();
                form.append('image', e.file);
                let [err, data] = await this.$api.uploadImageApi(form)
                if (data.code === 200) {
                    this.addForm.image.push(data.result);
                }
            },
            handlerStart(item, index) {
                this.start = item
                this.startIndex = index
            },
            handlerEnd(item, index) {
                if (this.startIndex === this.endIdnex) return;
                this.addForm.image.splice(this.startIndex, 1, this.end);
                this.addForm.image.splice(this.endIdnex, 1, this.start);
            },
            handlerEnter(item, index) {
                this.end = item
                this.endIdnex = index
            },
            @formVerify()
            async adviceAdd() {
                this.loading = true;
                let [e, data] = await this.$api.adviceAddApi(this.addForm);
                this.loading = false;
                if (data.code === 200) {
                    this.$message.success('提交成功！')
                } else {
                    this.$message.warning(data.error)
                }
            }
        },
    }
</script>

<style scoped lang="less">
    .img-content {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;

        .img-content-item {
            width: 150px;
            height: 150px;
            object-fit: cover;
            margin-right: 20px;
            margin-bottom: 20px;
        }
    }

    .drag-move {
        transition: 0.3s;
    }
</style>
